import { twMerge } from 'tailwind-merge'

export interface BackgroundImageProps extends React.HTMLAttributes<HTMLDivElement> {
  imageSrc: string
}

export const BackgroundImage = ({ imageSrc, className, ...props }: BackgroundImageProps) => {
  return (
    <div
      className={twMerge(
        'absolute top-0 left-0 pointer-events-none z-10',
        'w-full h-full',
        'bg-cover bg-center bg-no-repeat opacity-20',
        'before:absolute before:top-0 before:left-0',
        'before:w-full before:h-full',
        'before:bg-overlay-to-primary',
        className
      )}
      style={{ backgroundImage: `url(${imageSrc})` }}
      {...props}
    />
  )
}

BackgroundImage.displayName = 'BackgroundImage'
